/* eslint-disable react/no-unescaped-entities */
import React from "react";
import { useTranslation } from "react-i18next";
import { AuroraBackground } from "@/components/AuroraBackground";
import { Reveal } from "@/components/Reveal";
import { CheckCircle2, Circle, Clock } from "lucide-react";

const Icon = ({ s }) =>
  s === "done" ? <CheckCircle2 className="text-[var(--aurora-gold)]" size={18} />
  : s === "now" ? <Clock className="text-[var(--aurora-cyan)]" size={18} />
  : <Circle className="text-white/40" size={18} />;

const RoadmapPage = () => {
  const { t } = useTranslation("site");
  const tk = (k, fb) => t(`roadmap.${k}`, fb);
  const columns = [
    { status: "done", h: tk("col1H"), items: [tk("col1I1"), tk("col1I2"), tk("col1I3"), tk("col1I4")] },
    { status: "now", h: tk("col2H"), items: [tk("col2I1"), tk("col2I2"), tk("col2I3")] },
    { status: "next", h: tk("col3H"), items: [tk("col3I1"), tk("col3I2"), tk("col3I3")] },
    { status: "explore", h: tk("col4H"), items: [tk("col4I1"), tk("col4I2"), tk("col4I3")] },
  ];
  return (
    <>
      <section className="relative pb-12">
        <AuroraBackground variant="soft" />
        <div className="relative mx-auto max-w-7xl px-5 lg:px-8 pt-8 lg:pt-12">
          <Reveal>
            <p className="eyebrow">{tk("kicker")}</p>
            <h1 className="mt-3 font-serif text-[2.4rem] sm:text-5xl lg:text-[4rem] tracking-tight font-light leading-tight max-w-3xl">
              {tk("title1")}{" "}<em className="italic aurora-shimmer-text">{tk("title2")}</em>
            </h1>
            <p className="mt-5 max-w-2xl text-white/72 text-lg font-light">{tk("subtitle")}</p>
          </Reveal>
        </div>
      </section>

      <section className="relative py-12">
        <div className="mx-auto max-w-5xl px-5 lg:px-8 grid md:grid-cols-2 gap-5">
          {columns.map((col) => (
            <Reveal key={col.h}>
              <div className="aurora-card p-7 h-full bg-[var(--aurora-coach)]/70">
                <p className="eyebrow">{col.h}</p>
                <ul className="mt-4 space-y-3">
                  {col.items.map((i) => (
                    <li key={i} className="flex gap-3 text-white/82 font-light">
                      <Icon s={col.status} />
                      <span>{i}</span>
                    </li>
                  ))}
                </ul>
              </div>
            </Reveal>
          ))}
        </div>
      </section>
    </>
  );
};

export default RoadmapPage;
